import React from 'react';
import CrudManager from '@/components/admin/CrudManager';

const AdminTestimonials = () => (
  <CrudManager
    title="Testimonials"
    subtitle="Verified customer voices shown on the homepage."
    endpoint="/admin/testimonials"
    idField="testimonial_id"
    columns={[
      { key: 'name', label: 'Name' },
      { key: 'location', label: 'Location' },
      { key: 'text', label: 'Quote', render: (t) => (t.text || '').slice(0, 60) + '…' },
      { key: 'rating', label: 'Rating' },
    ]}
    initial={{ name: '', location: '', text: '', rating: 5 }}
    fields={[
      { key: 'name', label: 'Name', required: true },
      { key: 'location', label: 'Location' },
      { key: 'text', label: 'Quote', type: 'textarea', rows: 3, required: true },
      { key: 'rating', label: 'Rating (1–5)', type: 'number' },
    ]}
  />
);
export default AdminTestimonials;
